<template>
    <div>
        <component @open="open" @show="showFullScreen" :is="compiledData"></component>
        <div v-if="files != []" class="viewer-container viewer-backdrop viewer-fixed viewer-hooper viewer-fade" ref="viewer"
             @keyup.space="slideNext" @keyup.esc="closeViewer">

            <div class="viewer-canvas-wrapper">

                <div class="viewer-canvas" id="viewerHooper" :class="{'nav-hovered-prev': hoveredPrev, 'nav-hovered-next': hoveredNext}">
                    <hooper @slide="slide" @afterSlide="afterSlide" class="carousel-thumbs viewer-carousel" ref="viewerHooper" :infiniteScroll="files.length < 2 ? false : true" :wheelControl="false">

                        <slide :key="index"
                               v-for="(item,index) in files">
                          <div class="item" v-if="item.mediaType == 'photo'">
                              <img v-lazy="item.path" alt=""  v-if="files != [] && (currentSlide == index+1 || currentSlidePrev == index) && isShowedViewer">
                              <div class="inner-nav" v-if="files.length > 1">
                                  <div class="prev" @click="slidePrev" @mouseover="hoveredPrev = true" @mouseleave="hoveredPrev = false"></div>
                                  <div class="next" @click="slideNext"  @mouseover="hoveredNext = true" @mouseleave="hoveredNext = false"></div>
                              </div>
                          </div>
                          <div class="item" v-else-if="item.mediaType == 'yt-video'">
                                <iframe width="1100"
                                        height="450"
                                        v-if="files != [] && (currentSlide == index+1 || currentSlidePrev == index) && isShowedViewer"
                                        :src="'https://www.youtube.com/embed/'+item.id+'?enablejsapi=1'"
                                        frameborder="0"
                                        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                                        allowfullscreen></iframe>
                                <div class="inner-nav" v-if="files.length > 1">
                                    <div class="prev" @click="slidePrev" @mouseover="hoveredPrev = true"
                                         @mouseleave="hoveredPrev = false"></div>
                                    <div class="next" @click="slideNext" @mouseover="hoveredNext = true"
                                         @mouseleave="hoveredNext = false"></div>
                                </div>
                            </div>
                            <div class="item" v-else-if="item.mediaType == 'vk-video'">
                                <iframe 
                                v-if="files != [] && (currentSlide == index+1 || currentSlidePrev == index) && isShowedViewer"
                                    :src="processedUrl(item.id)" 
                                    width="853" height="480" 
                                    allow="autoplay; encrypted-media; fullscreen; picture-in-picture; screen-wake-lock;" 
                                    frameborder="0" allowfullscreen>
                                </iframe>
                                <div class="inner-nav" v-if="files.length > 1">
                                    <div class="prev" @click="slidePrev" @mouseover="hoveredPrev = true"
                                         @mouseleave="hoveredPrev = false"></div>
                                    <div class="next" @click="slideNext" @mouseover="hoveredNext = true"
                                         @mouseleave="hoveredNext = false"></div>
                                </div>
                            </div>
                        </slide>
                        <hooper-navigation slot="hooper-addons" v-if="files.length > 1"></hooper-navigation>
                    </hooper>
                </div>
                <div role="button" class="viewer-button viewer-close" @click="closeViewer" id="closeFullscreenViewer"></div>
                <div class="photo-num">
                    {{currentSlide}}
                </div>
            </div>
        </div>
    </div>

</template>

<script>
	import {mapState} from 'vuex'
    import {Hooper, Slide, Navigation as HooperNavigation} from 'hooper'; // carousel

    export default {
        name: "DynamicHtml",
        components: {
            Hooper,
            Slide,
            HooperNavigation,
        },
        props:{
            html: {
               default: ''
            },
            opened: {
               default: false
           }
        },
        data () {
            return {
                currentSlide: 1,
                currentSlidePrev: 1,
                hoveredPrev: false,
                hoveredNext: false,
                isShowedViewer: false,
				isZoomInit: false,
            }
        },
        computed: {
			...mapState({
                tumblers: state => state.rules.tumblers,
            }),
            compiledData () {
                let html = this.html.replace(/clickprevent/g,'@click.prevent').replace(/youtubeimg/g,'//img.youtube.com/vi/').replace(/\$emit\(show/g,'$emit(\'show\'').replace(/\$emit\(open/g,'$emit(\'open\'');
                return {
                    template: `<div class="js-rule-content">${html}</div>`
                }
            },
            files(){
                let result = this.html.match(/<span[\s\S]*?class="(image|youtube)"[\s\S]*?\/span>/gi);
                let IDs = [];
                let files = [];
                for(let r in result){
                    let div = document.createElement('div');
                    div.innerHTML = result[r];
                    let type;
                    let element;
                    let elementId;

                    if(div.querySelector("span.image")){
                        element = div.querySelector("span.image");
                        type = 'image';
                        elementId = element.dataset.id;
                    }
                    if(div.querySelector("span.youtube")){
                        element = div.querySelector("span.youtube");
                        type = element.getAttribute("data-type") ? element.getAttribute("data-type") : 'youtube';
                        elementId = element.dataset.id;
                    }
                    //if(element && IDs.indexOf(element.dataset.id) === -1){
                        IDs.push(elementId);
                        if(type === 'image'){
                            let href = element.dataset.href;
                            files.push({id:elementId,path:href,icon:href,mediaType: 'photo'});
                        }
                        if(type === 'youtube'){
                            let path = '//img.youtube.com/vi/' + elementId + '/mqdefault.jpg'
                            files.push({id: elementId, path: path, icon: path, mediaType: 'yt-video'});
                        }
                        if (type === 'vk') {
                            let id = elementId;
                            let path = '//img.youtube.com/vi/12/mqdefault.jpg';
                            files.push({id: id, path: path, icon: path, mediaType: 'vk-video'});
                        }
                    //}

                }
                return files;
            }
        },
        mounted(){
            setTimeout(() => {
                this.$refs.viewerHooper.update();
            }, 100);
			this.zoomInit();
        },
		watch: {
			'tumblers.zoom.value'(val, oldVal){
				if(val && !this.isZoomInit){
					this.zoomInit();
				}
			}
		},
        methods: {
            processedUrl(id) {
                return id.replace(/&amp;/g, "&").replace(/amp;/g,"");
            },
			afterSlide(){
					document.querySelector('.hooper-track').focus();
			},
			zoomInit(){
				let images = document.querySelectorAll('span.image');
				if(images.length){
					for (let el of images) {
						let img = document.createElement('img');
						let href = el.getAttribute('data-href');
						img.src = href;
						el.append(img);
					}
					this.isZoomInit = true;
				}
			},
            slide(payload){
                this.currentSlide = +payload.currentSlide == -1 ? this.files.length : +payload.currentSlide +1;
                if(this.files && +this.currentSlide > this.files.length){
                    this.currentSlide = 1;
                }
                this.currentSlidePrev = +payload.slideFrom
                this.pauseVideos();
            },
            loaded(e){
              console.log('loaded')
            },
            showFullScreen(id){
                for(let i in this.files){
                    if(this.files[i].id == id){
						document.getElementsByTagName('body')[0].classList.add("noscroll");
                        this.showViewer(i);
                        break;
                    }
                }
            },
            open(href) {
                let  link = document.createElement('a');
                link.setAttribute('href',href);
                //link.setAttribute('download','download');
                link.setAttribute('target','_blank');
                link.click();
            },
            pauseVideos() {
                [...document.getElementsByTagName('iframe')].forEach(i => i.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*'));
            },
            closeViewer() {
				document.getElementsByTagName('body')[0].classList.remove("noscroll");
                this.pauseVideos();
                if (this.isShowedViewer) {
                    this.$refs.viewer.classList.add('viewer-transition');
                    this.$refs.viewer.classList.remove('viewer-in');
                    document.getElementsByTagName('body')[0].classList.remove("popup-noscroll");
                    let self = this;
                    setTimeout(function () {
                        if (self.$refs.viewer) {
                            self.$refs.viewer.classList.remove('viewer-transition');
                        }
                        if (self.$refs.viewerHooper) {
                            self.$refs.viewerHooper.restart();
                        }
                        self.isShowedViewer = false;
                    }, 200);
                }
            },
            showViewer(index) {
                this.$refs.viewer.classList.add('opening');
                this.$refs.viewerHooper.slideTo(index);
                this.$refs.viewer.classList.add('viewer-transition');
                this.$refs.viewer.querySelector('.hooper-track').setAttribute('tabindex', 0);
                let self = this;
                setTimeout(function () {
                    self.$refs.viewer.classList.remove('viewer-transition');
                    self.$refs.viewer.classList.remove('opening');
                }, 400);
                setTimeout(function () {
                    self.$refs.viewer.classList.add('viewer-in');
                    document.getElementsByTagName('body')[0].classList.add("popup-noscroll");
                    self.isShowedViewer = true;
                    self.$refs.viewer.querySelector('.hooper-track').focus();
                }, 10);
            },
            slideNext() {
                this.$refs.viewerHooper.slideNext();
				document.querySelector('.hooper-track').focus();
            },
            slidePrev() {
                this.$refs.viewerHooper.slidePrev();
				document.querySelector('.hooper-track').focus();
            },
        },

    }
</script>
<style>

</style>
